import { initStore } from './init';
import modules from './modules';
import plugins from './plugins';

export default initStore({
	modules,
	plugins
});
